import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{attrs:{"x-small":_vm.chipXSmallSize,"small":_vm.chipSmallSize,"outlined":"","color":"var(--agoraLight)"},on:{"click":_vm.clicked}},[_vm._v(_vm._s(_vm.badge.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }